<template>
    <div class="liga">
        <!-- navbar -->
        <Navbar showBackButton></Navbar>

        <div class="poveznice">
            <Poveznice></Poveznice>
        </div>

        <div class="container">
            <PanelPokreni v-if="appState == 'round-in-progress'"/>
        </div>

        <transition name="fade-translate" appear>
            <Loading :loadingState="loadingState">
                    <KreirajGrupuField v-on:data="onKreirajGroupFieldData" v-if="!groupId"></KreirajGrupuField>
                    <KreirajGrupuLink v-on:deleted="groupRemoved()" v-if="groupId" :groupId="groupId"></KreirajGrupuLink>
            </Loading>
        </transition>

  </div>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import Poveznice from '../components/Poveznice.vue'
import KreirajGrupuField from '../components/group/KreirajGrupuField'
import KreirajGrupuLink from '../components/group/KreirajGrupuLink'
import Loading from '../components/common/Loading'
import LoadingState from '../utils/loading/LoadingState'
import PanelPokreni from '../components/PanelPokreni'

export default {
    name: 'kreiraj_grupu',
    data () {
        return {
            groupId: null,
            groupName: null
        }
    },
    components: {
        Navbar,
        Poveznice,
        KreirajGrupuField,
        KreirajGrupuLink,
        Loading,
        PanelPokreni
    },
    mounted () {
        if (this.userGroupOwner) {
            this.groupId = this.userGroupOwner
        }
    },
    methods: {
        onKreirajGroupFieldData (data) {
            if (data.success === true) {
                this.groupId = data.groupId
                this.groupName = data.name
                this.sendGA(true)
            }
        },
        async groupRemoved () {
            this.$store.commit('setUserDataVlasnikGrupe', undefined)
            this.groupId = undefined
            await this.$db.metadata.fetchMetadata()
            this.sendGA(false)
        },
        sendGA (grupaCreated) {
            // eslint-disable-next-line no-undef
            gtag('event', 'click', {
                'event_category': 'Korisnička grupa',
                'event_label': `${grupaCreated ? 'Kreirana grupa' : 'Obrisana grupa'}`
            })
        }
    },
    watch: {
        userGroupOwner (after, before) {
            if (after) {
                this.groupId = after
            }
        }
    },
    computed: {
        loadingState () {
            try {
                if (this.loading) {
                    return LoadingState.LOADING
                } else {
                    return LoadingState.SUCCESS
                }
            } catch (error) {
                return LoadingState.LOADING
            }
        },
        loading () {
            try {
                return !this.$store.state.metadata.loaded
            } catch (error) {
                return true
            }
        },
        userGroupOwner () {
            try {
                return this.$store.state.metadata.userData.groupOwner
            } catch (error) {
                return false
            }
        },
        appState () {
            return this.$store.state.appState
        }
    }
}
</script>

<style lang="scss" scoped>
.liga {
    padding: 22px 0;

    .poveznice {
        margin-bottom: 30px;
    }

    .container {
        padding: 0 24px 24px;
    }
}

@media only screen and (min-width: 800px) {
    .liga {
        max-width: 1280px;
        margin: auto;
    }
}
</style>
